import React, { useEffect, useState } from "react";
import { FaArrowRight } from "react-icons/fa";
import logo from "./img/logo 1.png";
import "./Login.css"; // Import the CSS file

import config from "../../../config/config.json";
import { apiCall } from "../../../services/ApiCall";
import { useLocation, useNavigate } from "react-router-dom";
import { Base64 } from 'js-base64';
import Loader from "../../CompanyFolder/CompanyList/Loader";

function Login() {
  const navigate = useNavigate();
  const location = useLocation();
  const [showPassword, setShowPassword] = useState(false);
  const [showLoader, setShowLoader] = useState(false);

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [forgotMessage, setForgotMessage] = useState("");

  const handleForgotPassword = async () => {
    const { isSuccess, data } = await apiCall(
      `${config.AUTH_API_URL}resetPassword`,
      {},
      { email: email },
      "POST"
    );
    setForgotMessage(data?.message || "If that email exists, a reset link has been sent.");
  };

  // EXACT ORIGINAL FUNCTIONS - NO CHANGES
  const handleSubmit = async (event) => {
    event.preventDefault();
    const { isSuccess, data } = await apiCall(
      `${config.AUTH_API_URL}login`,
      {},
      {
        email: email,
        password: password,
        userType: 'ADMIN'
      },
      "POST"
    );

    if (isSuccess) {
      localStorage.setItem("userData", JSON.stringify(data.data));
      localStorage.setItem("token", JSON.stringify(data.data?.accessToken));
      navigate("/dashboard");
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const loginAdmin = async (hide = false, email, password, decodedId) => {
    const { isSuccess, data } = await apiCall(
      `${config.AUTH_API_URL}login`,
      {},
      {
        email: email,
        password: password,
      },
      "POST"
    );

    if (isSuccess) {
      localStorage.setItem("userData", JSON.stringify(data.data));
      localStorage.setItem("token", JSON.stringify(data.data?.accessToken));
      setShowLoader(false);
      let pushToRoute;
      if (window.location.href.includes("mainContactLogin")) {
        pushToRoute = `/#/all-request?hide=${hide}&mainContactLogin=true&requestId=${decodedId}`;
      } else if (window.location.href.includes("siteManagerLogin")) {
        pushToRoute = `/#/request-form?hide=${hide}&siteManagerLogin=true&requestId=${decodedId}`;
      } else if (window.location.href.includes("siteAdminLogin")) {
        pushToRoute = `/#/request-form?hide=${hide}&siteAdminLogin=true&requestId=${decodedId}`;
      }

      if (pushToRoute) {
        window.location.href = pushToRoute;
      }
    }
  };

  const decryptJWTToken = async (token) => {
    try {
      const response = await fetch(`${config.AUTH_API_URL}decrypt-token`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token })
      });

      if (!response.ok) {
        throw new Error('Invalid token');
      }

      return await response.json();
    } catch (error) {
      throw new Error('Failed to decrypt token');
    }
  };

  const functionextractAndDecodeUrl = async (url) => {
    const urlObj = new URL(url);
    const token = urlObj.searchParams.get('token');
    let encodedId, encodedUser, encodedPassword;
    if (token) {
      try {
        const { id, user, password } = await decryptJWTToken(token);
        encodedId = id;
        encodedUser = user;
        encodedPassword = password;
        if (!id || !user || !password) {
          console.error("Decrypted token missing required fields.");
          return;
        }
      } catch (error) {
        console.error("Failed to decrypt token:", error);
      }
    } else {
      // Fallback to old logic
      encodedId = urlObj.searchParams.get('id');
      encodedUser = urlObj.searchParams.get('user');
      encodedPassword = urlObj.searchParams.get('password');
    }

    if (encodedId && encodedUser && encodedPassword) {
      const decodedId = Base64.decode(encodedId);
      const decodedEmail = Base64.decode(encodedUser);
      const decodedPassword = Base64.decode(encodedPassword);
      loginAdmin(true, decodedEmail, decodedPassword, decodedId);
    } else {
      console.error("Missing parameters in URL.");
    }
  };

  useEffect(() => {
    const currentUrl = window.location.href;
    if (
      currentUrl.includes("mainContactLogin") ||
      currentUrl.includes("siteManagerLogin") ||
      currentUrl.includes("siteAdminLogin")
    ) {
      setShowLoader(true);
      functionextractAndDecodeUrl(currentUrl);
    }
  }, []);

  if (showLoader) {
    return <Loader />
  }

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.logo}>

          <img src={logo} alt="Logo" style={styles.logoImage} />
          <p style={{
            color: "rgba(255, 255, 255, 0.8)",
            fontSize: "16px",
            marginTop: "12px",
            marginBottom: "0",
            fontWeight: "400",
            letterSpacing: "0.5px"
          }}>
            Powered by Businessvalue365
          </p>
        </div>
        <div className="align-item-center">
          <div style={styles.title}>
            Sign-in
          </div>
          <input
            type="email"
            placeholder="Email Address *"
            style={styles.input}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <div style={styles.passwordContainer}>
            <input
              className="Password"
              placeholder="Password *"
              style={styles.input}
              type={showPassword ? "text" : "password"}
              onChange={(e) => setPassword(e.target.value)}
            />
            <i
              className={`fa-solid fa-eye${showPassword ? "-slash" : ""}`}
              onClick={togglePasswordVisibility}
              style={styles.eyeIcon}
            ></i>
          </div>
        </div>

        <div style={styles.actionContainer}>
          <button style={styles.button} onClick={(e) => handleSubmit(e)}>
            LOGIN <FaArrowRight style={styles.buttonIcon} />
          </button>
          <a style={styles.link} onClick={handleForgotPassword}>Forgot your password?</a>
          {forgotMessage && (
            <p style={{ color: "white", marginTop: "0.5rem", fontSize: "14px" }}>{forgotMessage}</p>
          )}
        </div>
      </div>
    </div>
  );
}

export default Login;

const styles = {
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "100vh",
    backgroundColor: "rgba(0, 80, 164, 1)",
    padding: "1rem",
  },
  card: {
    backgroundColor: "rgba(26, 77, 143, 0.95)",
    borderRadius: "16px",
    padding: "2rem 1.5rem",
    width: "100%",
    maxWidth: "400px",
    boxShadow: "0 8px 32px rgba(0, 0, 0, 0.3)",
    textAlign: "center",
    backdropFilter: "blur(10px)",
    border: "1px solid rgba(255, 255, 255, 0.1)",

    // Mobile responsiveness
    "@media (max-width: 480px)": {
      padding: "1.5rem 1rem",
      margin: "1rem",
    }
  },
  logo: {
    marginBottom: "1rem",

    "@media (max-width: 480px)": {
      marginBottom: "1.5rem",
    }
  },
  logoImage: {
    maxWidth: "100%",
    height: "auto",
    maxHeight: "80px",

    "@media (max-width: 480px)": {
      maxHeight: "60px",
    }
  },
  title: {
    color: "white",
    marginBottom: "1.5rem",
    fontSize: "1.5rem",
    fontWeight: "500",

    "@media (max-width: 480px)": {
      fontSize: "1.25rem",
      marginBottom: "1rem",
    }
  },
  input: {
    width: "100%",
    padding: "12px 16px",
    marginBottom: "1rem",
    borderRadius: "8px",
    backgroundColor: "rgba(0, 80, 164, 0.3)",
    color: "white",
    border: "1px solid rgba(255, 255, 255, 0.3)",
    fontSize: "16px",
    boxSizing: "border-box",
    transition: "all 0.3s ease",

    "&:focus": {
      outline: "none",
      borderColor: "rgba(255, 255, 255, 0.6)",
      backgroundColor: "rgba(0, 80, 164, 0.5)",
    },

    "&::placeholder": {
      color: "rgba(255, 255, 255, 0.7)",
    },

    "@media (max-width: 480px)": {
      padding: "10px 14px",
      fontSize: "16px", // Prevent zoom on iOS
    }
  },
  passwordContainer: {
    position: "relative",
    marginBottom: "1rem",
  },
  eyeIcon: {
    position: "absolute",
    right: "16px",
    top: "50%",
    transform: "translateY(-50%)",
    cursor: "pointer",
    color: "rgba(255, 255, 255, 0.8)",
    fontSize: "16px",
    transition: "color 0.3s ease",

    "&:hover": {
      color: "white",
    },

    "@media (max-width: 480px)": {
      right: "14px",
      fontSize: "14px",
    }
  },
  actionContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "1rem",
    marginTop: "2rem",
    alignItems: "center",

    "@media (min-width: 481px)": {
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
    },

    "@media (max-width: 480px)": {
      marginTop: "1.5rem",
    }
  },
  button: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    fontWeight: "600",
    padding: "12px 24px",
    backgroundColor: "white",
    color: "rgba(0, 80, 164, 1)",
    fontSize: "16px",
    border: "none",
    borderRadius: "8px",
    cursor: "pointer",
    transition: "all 0.3s ease",
    minWidth: "120px",

    "&:hover": {
      backgroundColor: "rgba(255, 255, 255, 0.9)",
      transform: "translateY(-1px)",
      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2)",
    },

    "&:active": {
      transform: "translateY(0)",
    },

    "@media (max-width: 480px)": {
      width: "100%",
      padding: "14px 24px",
      fontSize: "16px",
    }
  },
  buttonIcon: {
    fontSize: "14px",
    transition: "transform 0.3s ease",
  },
  link: {
    color: "rgba(255, 255, 255, 0.9)",
    textDecoration: "none",
    fontSize: "14px",
    cursor: "pointer",
    transition: "color 0.3s ease",

    "&:hover": {
      color: "white",
      textDecoration: "underline",
    },

    "@media (max-width: 480px)": {
      fontSize: "13px",
      textAlign: "center",
    }
  },
};